import { Input, Skeleton, Tag } from 'antd';
import styles from './topicList.module.scss';
import { GoChevronLeft } from 'react-icons/go';
import { ITellStoryTopicsRes } from 'src/core/repo/tellStory/type';
import { FaSearch } from 'react-icons/fa';
import { FaX } from 'react-icons/fa6';
import { useStore } from '@store';
import { ReactNode, useMemo, useState } from 'react';
import notFoundImage from '@assets/images/ai4.png';

interface Props {
  items?: ITellStoryTopicsRes[];
  isLoading: boolean;
  onBack: () => void;
  handleSelectTopic: (topic: ITellStoryTopicsRes) => void;
  language: string;
}

const colors = [
  { bg: '#FFD33826', text: '#222' }, // روشن
  { bg: '#9C1DE826', text: '#222' }, // روشن
  { bg: '#F1568F26', text: '#222' }, // روشن
  { bg: '#B0E0E626', text: '#222' }, // روشن
  { bg: '#CBAACB26', text: '#222' }, // روشن
  { bg: '#FFD1DC26', text: '#222' }, // روشن
  { bg: '#F8F8F8', text: '#222' }, // روشن
  { bg: 'rgba(186, 109, 232, 0.5)', text: '#fff' }, // روشن
  { bg: '#622E9D26', text: '#000' }, // روشن

  // پاستیلی‌ها
  { bg: '#F8F8F8', text: '#222' }, // روشن
  { bg: '#B0E0E626', text: '#222' }, // روشن
  { bg: '#622E9D26', text: '#222' }, // روشن
  { bg: '#F1568F26', text: '#222' }, // روشن
  { bg: '#F1568F26', text: '#222' }, // روشن  ];
];

const TopicList = ({
  items,
  isLoading,
  onBack,
  handleSelectTopic,
  language,
}: Props) => {
  const [selectedTags, setSelectedTags] = useState<number[]>([]);
  const [query, setQuery] = useState('');
  const { theme } = useStore();

  const handleChange = (tag: number | string, checked: boolean) => {
    const id = Number(tag); // یک‌دست کردن نوع
    setSelectedTags((prev) =>
      checked ? [...prev, id] : prev.filter((t) => t !== id),
    );
  };

  const filteredTopics = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    return items?.filter((t) => {
      const matchesQuery =
        !normalized || t.Title?.toLowerCase().includes(normalized);
      const matchesSelectedTags =
        selectedTags.length === 0 ||
        selectedTags.includes(Number(t.TrainingTopicID));
      return matchesQuery && matchesSelectedTags;
    });
  }, [query, items, selectedTags]);

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.description_wrapper}>
          <button onClick={onBack} className={styles.back_button}>
            <GoChevronLeft size={22} />
            <p>Back</p>
          </button>
          <h1 style={{ color: theme === 'night' ? '#fff' : '#000' }}>
            Select your topic
          </h1>
        </div>
        {/* search input for topics */}
        <div className={styles.filter_methods}>
          <Input
            size="large"
            variant="outlined"
            placeholder="Search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            prefix={<FaSearch />}
            addonAfter={<FaX onClick={() => setQuery('')} />}
          />
        </div>
        {/* quick asses topic */}
        <div
          className={styles.topic_tags}
          dir={language === 'Persian' ? 'rtl' : 'ltr'}
          lang={language === 'Persian' ? 'fa' : 'en'}>
          {items?.map<ReactNode>((tag) => (
            <Tag.CheckableTag
              key={tag.TrainingTopicID}
              checked={selectedTags.includes(tag.TrainingTopicID)}
              onChange={(checked) =>
                handleChange(tag.TrainingTopicID, checked)
              }>
              {tag.Title}
            </Tag.CheckableTag>
          ))}
        </div>
        {/* topic cards */}
        <div className={styles.topic_cards}>
          {isLoading ? (
            Array.from({ length: 4 }, (_, i) => (
              <Skeleton.Input className={styles.topic_card} active key={i} />
            ))
          ) : !filteredTopics || !items ? (
            <div>
              <div className={styles.not_found_wrapper}>
                <img src={notFoundImage} alt="not found image" />
                <h1>Nothing found for you ...</h1>
              </div>
            </div>
          ) : (
            filteredTopics.map((topic, idx) => {
              const { bg, text } = colors[idx % colors.length];
              return (
                <div
                  dir={topic.dir}
                  onClick={() => handleSelectTopic(topic)}
                  key={topic.TrainingTopicID}
                  style={{ backgroundColor: bg }}
                  className={styles.topic_card}>
                  <div className={styles.topic_card_desc}>
                    <h3>{topic.Title}s</h3>
                    <p>{topic.Description}</p>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default TopicList;
